import errors from './errors';
import themes from './theme';
import features from './features';
import common from '../common';
import { CAI_MATERIAL } from '@cai/material';

export default {
  ...common,
  mobileTicket: 'Mobiililippu',
  ...features,
  save: 'Tallenna',
  username: 'Käyttäjänimi',
  password: 'Salasana',
  login: 'Kirjaudu',
  required: 'Pakollinen',
  light: 'Vaalea',
  dark: 'Tumma',
  rememberMe: 'Muista minut',
  eula: 'EULA',
  copyright: '© {year} - Command Alkon, Inc.',
  termsAndConditions: 'Käyttöehdot',
  privacyPolicy: 'Tietosuojakäytäntö',
  customer: 'Asiakas',
  project: 'Projekti',
  isBillable: 'Laskutettava',
  dispatchDateTime: 'Päivämäärä',
  orderId: 'Tilaus',
  ticketId: 'Lippu',
  location: 'Sijainti',
  vehicleTypeName: 'Ajoneuvo',
  product: 'Tuote',
  products: 'Tuote',
  salesTax: 'Myyntivero',
  totalPrice: 'Yhteensä',
  extendedPrice: 'Laajennettu',
  destination: 'Kohde',
  productId: 'Tuote',
  statusCode: 'Tila',
  vehicleTypeId: 'Ajoneuvotyypin ID',
  locationId: 'Sijainnin ID',
  customerId: 'Asiakkaan ID',
  projectId: 'Projektin ID',
  dispatchTime: 'Aika',
  showAll: 'Näytä kaikki',
  hideAll: 'Piilota kaikki',
  undoChanges: 'Kumoa muutokset',
  resetColumns: 'Nollaa sarakkeet',
  displayRowCount: `Näytetään {count, plural, 
    =0 {0 riviä} 
    one {# rivi} 
    other {# riviä} 
  }`,
  columnFilters: 'Sarakefiltterit',
  visible: 'Näkyvä',
  hidden: 'Piilotettu',
  itemDetail: 'Tuotteen tiedot',
  quantity: 'Määrä',
  quantityMaxWaterToAdd: 'Määrä (Maksimi vesi lisättävä: {maxWaterQuantity})',
  unloadingMethod: 'Purku menetelmä',
  time: 'Aika',
  eventStatus: 'Tila',
  MTQ_abbr: 'm³',
  EA_abbr: 'kpl',
  LTR_abbr: 'L',
  YDQ_abbr: 'y³',
  GLL_abbr: 'gal',
  MTQ_text: 'Kuutiometrit',
  M3_text: 'Kuutiometrit',
  EA_text: 'Kukin',
  LTR_text: 'Litrat',
  YDQ_text: 'Kuutiot jaardit',
  GLL_text: 'Gallona',
  ACR_text: 'Aakria',
  HUR_text: 'Tunti',
  INH_text: 'Tuuma',
  FOT_text: 'Jalka',
  YRD_text: 'Jaardi',
  MMT_text: 'Millimetri',
  CMT_text: 'Senttimetri',
  MTR_text: 'Metri',
  SMI_text: 'Maili (laki)',
  KMT_text: 'Kilometri',
  INK_text: 'Neliötuuma',
  FTK_text: 'Neliöjalka',
  YDK_text: 'Neliöjaardi',
  MIK_text: 'Neliömaili',
  CMK_text: 'Neliösenttimetri',
  MTK_text: 'Neliömetri',
  KMK_text: 'Neliökilometri',
  INQ_text: 'Kuutiotuuma',
  MMQ_text: 'Kuutiomillimetri',
  FTQ_text: 'Kuutiot',
  CMQ_text: 'Kuutiocentimetri',
  OZA_text: 'Neste unssi',
  PT_text: 'Pintti',
  QT_text: 'Quart',
  MLT_text: 'Millilitra',
  ONZ_text: 'Unssi',
  LBR_text: 'Pound',
  STN_text: 'Toni',
  GRM_text: 'Gramma',
  KGM_text: 'Kilogramma',
  TNE_text: 'Tonni',
  PS_text: 'Pound per Square Inch',
  MPA_text: 'Megapascal',
  C56_text: 'Newton per neliömillimetri',
  C62_text: 'Yksi',
  NL_text: 'Kuorma',
  MT_text: 'Matto',
  P1_text: 'Prosentti',
  CEL_text: 'Celsius-aste',
  FAH_text: 'Fahrenheit-aste',
  BLL_text: 'Tynnyri',
  CLT_text: 'Sentilitra',
  DLT_text: 'Desilitra',
  GLI_text: 'Imperial Gallon',
  '2U_text': 'Megagramma',
  SA_text: 'Säkki',
  '60_text': 'Prosentti painosta',
  BG_text: 'Pussi',
  SEC_text: 'Sekunti',
  MIN_text: 'Minuutti',
  '64_text': 'Pound per square inch - Gauge',
  SP_text: 'Hyllypaketti',
  MMK_text: 'Neliömillimetri',
  MTN_text: 'Metriikka tonni',
  GT_text: 'Gigatonni',
  '/NL_text': 'Per kuorma',
  '/EA_text': 'Per määrä',
  '/H/ + h_text': 'Per tunti',
  '/YQ/ + YDQ_text': 'Per kuutiota',
  '/MQ/ + MTQ_text': 'Per kuutiometri',
  '/MN/ + MIN_text': 'Per minuutti',
  '/MT_text': 'Per metri',
  DSG_text: 'Annos',
  '/C_text': 'Per 100 painoa',
  '64_2_text': 'Erityinen',
  MTQ: `{value, plural,
    =0 {0 m³}
    one {1 m³}
    other {# m³}
  }`,
  M3: `{value, plural,
    =0 {0 m³}
    one {1 m³}
    other {# m³}
  }`,
  LTR: `{value, plural,
    =0 {0 Litroa}
    one {1 Litro}
    other {# Litroa}
  }`,
  TO: `{value, plural,
    =0 {0 Tonnia}
    one {1 Tonni}
    other {# Tonnia}
  }`,
  ITEM: `{value, plural,
    =0 {0 Tuotetta}
    one {1 Tuote}
    other {# Tuotetta}
  }`,
  YDQ_short: `{value, plural,
    =0 {0 y³}
    one {1 y³}
    other {# y³}
  }`,
  YDQ: `{value, plural,
    =0 {0 Kuutiota jaardia}
    one {1 Kuutiota jaardia}
    other {# Kuutiota jaardia}
  }`,
  GLL: `{value, plural,
    =0 {0 Gallonaa}
    one {1 Gallona}
    other {# Gallonaa}
  }`,
  EA: `{value, plural,
    =0 {0 Kukin}
    one {1 Kukin}
    other {# Kukin}
  }`,
  MIN: `{value, plural,
    =0 {0 Minuuttia}
    one {1 Minuutti}
    other {# Minuuttia}
  }`,
  ACR: `{value, plural,
    =0 {0 Aakria}
    one {1 Aakria}
    other {# Aakria}
  }`,
  HUR: `{value, plural,
    =0 {0 Tuntia}
    one {1 Tunti}
    other {# Tuntia}
  }`,
  INH: `{value, plural,
    =0 {0 Tuumaa}
    one {1 Tuuma}
    other {# Tuumaa}
  }`,
  FOT: `{value, plural,
    =0 {0 Jalkaa}
    one {1 Jalka}
    other {# Jalkaa}
  }`,
  YRD: `{value, plural,
    =0 {0 Jaardia}
    one {1 Jaardi}
    other {# Jaardia}
  }`,
  MMT: `{value, plural,
    =0 {0 Millimetriä}
    one {1 Millimetri}
    other {# Millimetriä}
  }`,
  CMT: `{value, plural,
    =0 {0 Senttimetriä}
    one {1 Senttimetri}
    other {# Senttimetriä}
  }`,
  MTR: `{value, plural,
    =0 {0 Metriä}
    one {1 Metri}
    other {# Metriä}
  }`,
  SMI: `{value, plural,
    =0 {0 Mailia (laki)}
    one {1 Maili (laki)}
    other {# Mailia (laki)}
  }`,
  KMT: `{value, plural,
    =0 {0 Kilometriä}
    one {1 Kilometri}
    other {# Kilometriä}
  }`,
  INK: `{value, plural,
    =0 {0 Neliötuumaa}
    one {1 Neliötuuma}
    other {# Neliötuumaa}
  }`,
  FTK: `{value, plural,
    =0 {0 Neliöjalkaa}
    one {1 Neliöjalka}
    other {# Neliöjalkaa}
  }`,
  YDK: `{value, plural,
    =0 {0 Neliöjaardia}
    one {1 Neliöjaardi}
    other {# Neliöjaardia}
  }`,
  MIK: `{value, plural,
    =0 {0 Neliömailia}
    one {1 Neliömaili}
    other {# Neliömailia}
  }`,
  CMK: `{value, plural,
    =0 {0 Neliösenttimetriä}
    one {1 Neliösenttimetri}
    other {# Neliösenttimetriä}
  }`,
  MTK: `{value, plural,
    =0 {0 Neliömetriä}
    one {1 Neliömetri}
    other {# Neliömetriä}
  }`,
  KMK: `{value, plural,
    =0 {0 Neliökilometriä}
    one {1 Neliökilometri}
    other {# Neliökilometriä}
  }`,
  INQ: `{value, plural,
    =0 {0 Kuutiotuumaa}
    one {1 Kuutiotuuma}
    other {# Kuutiotuumaa}
  }`,
  MMQ: `{value, plural,
    =0 {0 Kuutiomillimetriä}
    one {1 Kuutiomillimetri}
    other {# Kuutiomillimetriä}
  }`,
  FTQ: `{value, plural,
    =0 {0 Kuutiota}
    one {1 Kuutio}
    other {# Kuutiota}
  }`,
  CMQ: `{value, plural,
    =0 {0 Kuutiocentimetriä}
    one {1 Kuutiocentimetri}
    other {# Kuutiocentimetriä}
  }`,
  OZA: `{value, plural,
    =0 {0 Neste unssia}
    one {1 Neste unssi}
    other {# Neste unssia}
  }`,
  PT: `{value, plural,
    =0 {0 Pinttia}
    one {1 Pintti}
    other {# Pinttia}
  }`,
  QT: `{value, plural,
    =0 {0 Quarttia}
    one {1 Quartti}
    other {# Quarttia}
  }`,
  MLT: `{value, plural,
    =0 {0 Millilitraa}
    one {1 Millilitra}
    other {# Millilitraa}
  }`,
  ONZ: `{value, plural,
    =0 {0 Unssia}
    one {1 Unssi}
    other {# Unssia}
  }`,
  LBR: `{value, plural,
    =0 {0 Punta}
    one {1 Punta}
    other {# Punta}
  }`,
  STN: `{value, plural,
    =0 {0 Tonnia}
    one {1 Tonni}
    other {# Tonnia}
  }`,
  GRM: `{value, plural,
    =0 {0 Grammaa}
    one {1 Gramma}
    other {# Grammaa}
  }`,
  KGM: `{value, plural,
    =0 {0 Kilogrammaa}
    one {1 Kilogramma}
    other {# Kilogrammaa}
  }`,
  TNE: `{value, plural,
    =0 {0 Tonnia}
    one {1 Tonni}
    other {# Tonnia}
  }`,
  PS: `{value, plural,
    =0 {0 psi}
    one {1 psi}
    other {# psi}
  }`,
  MPA: `{value, plural,
    =0 {0 Megapascalia}
    one {1 Megapascal}
    other {# Megapascalia}
  }`,
  C56: `{value, plural,
    =0 {0 Newtonia per neliömillimetri}
    one {1 Newton per neliömillimetri}
    other {# Newtonia per neliömillimetri}
  }`,
  C62: `{value, plural,
    =0 {0 Yksi}
    one {1 Yksi}
    other {# Yksi}
  }`,
  NL: `{value, plural,
    =0 {0 Kuormaa}
    one {1 Kuorma}
    other {# Kuormaa}
  }`,
  MT: `{value, plural,
    =0 {0 Mattoa}
    one {1 Matto}
    other {# Mattoa}
  }`,
  P1: `{value, plural,
    =0 {0 Prosenttia}
    one {1 Prosentti}
    other {# Prosenttia}
  }`,
  CEL: `{value, plural,
    =0 {0 Celsius-astetta}
    one {1 Celsius-aste}
    other {# Celsius-astetta}
  }`,
  FAH: `{value, plural,
    =0 {0 Fahrenheit-astetta}
    one {1 Fahrenheit-aste}
    other {# Fahrenheit-astetta}
  }`,
  BLL: `{value, plural,
    =0 {0 Tynnyriä}
    one {1 Tynnyri}
    other {# Tynnyriä}
  }`,
  CLT: `{value, plural,
    =0 {0 Sentilitraa}
    one {1 Sentilitra}
    other {# Sentilitraa}
  }`,
  DLT: `{value, plural,
    =0 {0 Desilitraa}
    one {1 Desilitra}
    other {# Desilitraa}
  }`,
  GLI: `{value, plural,
    =0 {0 Gallonaa}
    one {1 Gallona}
    other {# Gallonaa}
  }`,
  '2U': `{value, plural,
    =0 {0 Megagrammaa}
    one {1 Megagramma}
    other {# Megagrammaa}
  }`,
  SA: `{value, plural,
    =0 {0 Säkkiä}
    one {1 Säkki}
    other {# Säkkiä}
  }`,
  60: `{value, plural,
    =0 {0 Prosentti painosta}
    one {1 Prosentti painosta}
    other {# Prosentti painosta}
  }`,
  BG: `{value, plural,
    =0 {0 Pussia}
    one {1 Pussi}
    other {# Pussia}
  }`,
  SEC: `{value, plural,
    =0 {0 Sekuntia}
    one {1 Sekunti}
    other {# Sekuntia}
  }`,
  64: `{value, plural,
    =0 {0 Pounds per square inch - Gauge}
    one {1 Pound per square inch - Gauge}
    other {# Pounds per square inch - Gauge}
  }`,
  SP: `{value, plural,
    =0 {0 Hyllypakettia}
    one {1 Hyllypaketti}
    other {# Hyllypakettia}
  }`,
  MMK: `{value, plural,
    =0 {0 Neliömillimetriä}
    one {1 Neliömillimetri}
    other {# Neliömillimetriä}
  }`,
  MTN: `{value, plural,
    =0 {0 metriikka tonnia}
    one {1 metriikka tonni}
    other {# metriikka tonnia}
  }`,
  GT: `{value, plural,
    =0 {0 Gigatonia}
    one {1 Gigatoni}
    other {# Gigatonia}
  }`,
  '/NL': `{value, plural,
    =0 {0 Per kuorma}
    one {1 Per kuorma}
    other {# Per kuorma}
  }`,
  '/EA': `{value, plural,
    =0 {0 Per määrä}
    one {1 Per määrä}
    other {# Per määrä}
  }`,
  '/H/ + h': `{value, plural,
    =0 {0 Per tunti}
    one {1 Per tunti}
    other {# Per tunti}
  }`,
  '/YQ/ + YDQ': `{value, plural,
    =0 {0 Per kuutiota}
    one {1 Per kuutiota}
    other {# Per kuutiota}
  }`,
  '/MQ/ + MTQ': `{value, plural,
    =0 {0 Per kuutiometri}
    one {1 Per kuutiometri}
    other {# Per kuutiometri}
  }`,
  '/MN/ + MIN': `{value, plural,
    =0 {0 Per minuutti}
    one {1 Per minuutti}
    other {# Per minuutti}
  }`,
  '/MT': `{value, plural,
    =0 {0 Per metri}
    one {1 Per metri}
    other {# Per metri}
  }`,
  DSG: `{value, plural,
    =0 {0 Annosta}
    one {1 Annos}
    other {# Annosta}
  }`,
  '/C': `{value, plural,
    =0 {0 Per 100 painoa}
    one {1 Per 100 painoa}
    other {# Per 100 painoa}
  }`,
  '64_2': `{value, plural,
    =0 {0 Erityinen}
    one {1 Erityinen}
    other {# Erityinen}
  }`,
  mixIdLabel: 'Sekoita ID/Kuvaus',
  productIdLabel: 'Tuote ID/Kuvaus',
  orderedQtyLabel: 'Tilattu määrä',
  loadedQtyLabel: 'Ladattu määrä',
  addedByCustomer: 'Asiakkaan lisäämä',
  PRINTED: 'Liputettu',
  LOADING_STARTED: 'Aloita lataus',
  LOADING_COMPLETE: 'Lataus valmis',
  TO_JOB: 'Lähti tehtaasta',
  ARRIVE_JOB: 'Saapuu sivustolle',
  UNLOADING: 'Aloita purku',
  END_UNLOADING: 'Purku valmis',
  LEAVE_JOB: 'Lähde työstä',
  IN_YARD: 'Pihalla',
  WASHING: 'Pesu',
  END_WASHING: 'Pesun loppu',
  PUMPING_STARTED: 'Aloita pumppaus',
  PUMPING_COMPLETE: 'Pumppaus valmis',
  READY_TO_PUMP: 'Valmis pumppaamaan',
  FIRST_WCCONTACT: 'Ensimmäinen veden ja sementin kontakti',
  plantName: 'Tehtaan nimi',
  plantAddress: 'Tehtaan osoite',
  loadingScheduleStart: 'Aikataulutettu latausaika',
  deliveryAddress: 'Toimitusosoite',
  phoneNumber: 'Puhelinnumero',
  unloadingScheduleStart: 'Suunniteltu purkuaika (ETA)',
  agreedUnloading: 'Tilatut purkuaikataulut',
  deliveryInformation: 'Toimitustiedot',
  next: 'Seuraava',
  material: 'Materiaali',
  loadingPoint: 'Latauspiste',
  unloadingPoint: 'Purkupiste',
  getDirections: 'Hanki reittiohjeet',
  comment: 'Kommentti',
  sapDeliveryNumber: 'SAP-toimitusnumero (BCC-numero)',
  salesOrderNumber: 'Myyntitilausnumero ja tuotelinja',
  wcDateTime: 'Päivämäärä ja aika W/C-kontaktissa',
  po: 'PO-numero',
  orderedByName: 'Tilauksen tehneen nimi',
  orderedByPhone: 'Tilauksen tehneen puhelinnumero',
  resourceId: 'Resurssi ID',
  totalLoadedQty: 'Yhteensä ladattu määrä mukaan lukien tämä kuorma',
  spacing: 'Kuormatilaa',
  deliveryFlow: 'Toimitusprosessi',
  timeOnSite: 'Kokonaisaika sivustolla/tilattu purkuaika',
  salesText: 'Myyntiteksti (materiaalin ID)',
  strengthClass: 'Lujuusluokka',
  environmentExposure: 'Ympäristön altistus',
  metExposureClasses: 'Kohdatut altistusluokat',
  dmax: 'Dmax',
  standardCert: 'Standardi (sertifiointi)',
  workabilityTarget: 'Asiakkaan työstettävyys tavoite',
  stoneQuality: 'Kivilaatu',
  sandQuality: 'Hiekkalaatu',
  targetWC: 'Tavoite W/C-suhde reseptistä',
  controlClass: 'Valvontaluokka',
  chlorideClass: 'Klooriluokka',
  typeAndStrength1: 'Sementin tyyppi ja lujuusluokka 1',
  typeAndStrength2: 'Sementin tyyppi ja lujuusluokka 2',
  typeOfAddition: 'Lisäyksen tyyppi',
  typeOfAdmixture: 'Lisäaineen tyyppi',
  orderedTemp: 'Tilattu lämpötila',
  fibers1: 'Kuitujen tyyppi ja sisältö 1',
  fibers2: 'Kuitujen tyyppi ja sisältö 2',
  calculatedMaturityTime: 'Lasketut kypsymisaika W/C-kontaktista',
  mixIdentity: 'Sekoita identiteetti',
  grade: 'Luokka',
  mixType: 'Sekoita tyyppi',
  maxAggSize: 'Maksimi kiviaineksen koko',
  maxAggType: 'Maksimi kiviaineksen tyyppi',
  cementType: 'Sementin tyyppi',
  admixtures: 'Lisäaineet',
  addmixDescription: 'Lisäaineen kuvaus',
  slump: 'Löysäys',
  minCementContent: 'Minimi sementin sisältö',
  maxWatCemRatio: 'Maksimi Vesi/Sementti suhde',
  maxWaterToAdd: 'Maksimi lisättävä vesi',
  mortarMinWorkingLife: 'Laastin minimi työikä',
  code: 'Koodi',
  dcClass: 'dcLuokka',
  chloride: 'Kloori',
  signedByHanson: 'Hansonin allekirjoittama',
  warmStamp: 'Lämmin leima',
  coldStamp: 'Kylmä leima',
  containsSikatard: 'Sisältää Sikatard',
  containsDelvo: 'Sisältää Delvo',
  generalDelivery: 'Yleiset toimitustiedot',
  materialInfo: 'Materiaalitiedot',
  water: 'Vesi',
  materialService: 'Materiaali / Palvelu',
  returnedMaterial: 'Palautettu materiaali',
  returnedConcrete: 'Palautettu betoni',
  waterAdded: 'Lisätty vesi',
  concreteOnTruck: 'Betoni kuorma-autossa',
  concreteOnTruckUom: 'Oletus betoni kuorma-autossa UOM',
  reason: 'Syytä',
  customerAddedWater: 'Asiakkaan lisäämä vesi',
  addWater: 'Lisää vettä',
  addedAt: 'Lisätty',
  addMaterialService: 'Lisää materiaali/palvelu',
  customerAddedProduct: 'Asiakkaan lisäämä tuote',
  addReturnedMaterial: 'Lisää palautettu materiaali',
  leftover: 'Ylijäämä',
  submitAcceptance: 'Lähetä hyväksyntä',
  accepted: 'Hyväksytty',
  rejected: 'Hylätty',
  customerAcceptance: 'Hyväksyntä',
  finalize: 'Viimeistele',
  earlyAcceptance: 'Ennakkohyväksyntä',
  materialSummary: 'Materiaalin yhteenveto',
  mix: 'Sekoita',
  ordered: 'Tilattu',
  loaded: 'Toimituskuorma',
  totalOrdered: 'Yhteensä tilattu määrä',
  loadedOrderQuantity: 'Ladattu tilausmäärä',
  loadedOrder: 'Ladattu tilaus',
  driverComment: 'Kuljettajan kommentti',
  driverCommentInternal: 'Kuljettajan kommentti (Sisäinen)',
  customerComment: 'Asiakkaan kommentti',
  editComment: 'Muokkaa kommenttia',
  addComment: 'Lisää kommentti',
  additionalInfo: 'Lisätiedot',
  onBoard: 'Laivalla',
  driver: 'Kuljettaja',
  commentInstruction: 'Kommentti ohje',
  signatureInstruction: 'Asiakkaan allekirjoitus *',
  customerSignature: 'Asiakkaan allekirjoitus',
  general: 'Yleinen',
  status: 'Tila',
  updateStatusTime: 'Päivitä tilan aika',
  delete: 'Poista',
  cancel: 'Peruuta',
  back: 'Takaisin',
  add: 'Lisää',
  edit: 'Muokkaa',
  done: 'Valmis',
  ok: 'OK',
  decline: 'Hylkää',
  Submit: 'Lähetä',
  submit: 'Lähetä',
  lastRefresh: 'Viimeisin päivitys',
  refreshEnabled: 'Ota päivitys käyttöön',
  id: 'ID',
  name: 'Nimi',
  invoiceable: 'Laskutettava',
  provideSignature: 'Anna allekirjoitus',
  ticket: 'Lippu',
  details: 'Yksityiskohdat',
  qrCode: 'QR-koodi',
  driverAcceptanceReason: 'Syytä',
  driverAcceptance: 'Kuljettajan hyväksyntä',
  'payment-method': 'Maksutavat',
  'add-payment-method': 'Lisää maksutapa',
  'reason-code': 'Syykoodi',
  'add-reason-code': 'Lisää syykoodi',
  'qr-code': 'QR-koodi',
  'unloading-method': 'Purku menetelmät',
  'add-unloading-method': 'Lisää purku menetelmä',
  'driver-comment': 'Kuljettajan kommentit',
  'add-driver-comment': 'Lisää kuljettajan kommentti',
  'driver-sellable': 'Kuljettaja myytävissä',
  vehicle: 'Ajoneuvot',
  'add-vehicle': 'Lisää ajoneuvo',
  'vehicle-type': 'Ajoneuvotyypit',
  vehicleTypes: 'Ajoneuvotyypit',
  vehicleType: 'Ajoneuvotyyppi',
  'add-vehicle-type': 'Lisää ajoneuvotyyppi',
  countries: 'Maat',
  country: 'Maa',
  type: 'Tyyppi',
  uom: 'UOM',
  mandatory: 'Pakollinen',
  qrTemplate: 'QR-koodin malli',
  includeMixInfo: 'Sisällytä sekoitustiedot QR-koodiin',
  includeTicketEvents: 'Sisällytä lipputapahtumat QR-koodiin',
  quantityField: 'Ota käyttöön määräkenttä',
  concreteOnTruckField: 'Ota käyttöön betoni kuorma-autossa kenttä',
  materialOnTruckField: 'Ota käyttöön materiaali kuorma-autossa kenttä',
  timeField: 'Ota käyttöön aikakenttä',
  reasonField: 'Ota käyttöön syykenttä',
  driverInstructions: 'Kuljettajan ohjeet',
  waitingForTicket: 'Odotetaan lippua...',
  createTestTicketForTruck: 'Luo testilippu kuorma-autolle',
  exceedsLoadedQuantity: 'Arvo ei voi ylittää ladattua määrää {loadedQuantity}.',
  maxQuantity: 'Maksimi määrä',
  maxQuantityError: 'Määrä ei voi ylittää määriteltyä maksimi määrää {maxQty}',
  maxValueError: 'Arvo ei voi ylittää määriteltyä maksimi arvoa {maxQty}',
  minValueError: 'Arvo ei voi olla pienempi kuin määritelty minimimäärä {minQty}',
  notAuthorized: 'Ei valtuutettu',
  enterTruckNumber: 'Syötä kuorma-auton numero',
  setTruckNumber: 'Aseta kuorma-auton numero',
  commentList: 'Kommenttilista',
  list: 'Lista',
  gridPreferences: 'Ruudukon asetukset',
  loadingUnloadingPoints: 'Lataus/Purku pisteet',
  activity: 'Toiminta',
  crn: 'Crn',
  update: 'Päivitä',
  CONCRETE: 'Betoni',
  WATER: 'Vesi',
  ADDITIVE: 'Lisäaine',
  'submit-signature-button': 'Hyväksy',
  'cancel-signature-button': 'Peruuta',
  uomCode: 'Oletus UOM',
  'product-type': 'Tuotetyypit',
  'add-product-type': 'Lisää tuotetyyppi',
  'add-product': 'Lisää tuote',
  'setup_driver-comment': 'Kuljettajan kommentit',
  setup_product: 'Tuotteet',
  'setup_product-type': 'Tuotetyypit',
  'setup_qr-code': 'QR-koodi',
  'setup_reason-code': 'Syykoodit',
  'setup_unloading-method': 'Purku menetelmät',
  'setup_entity-mt': 'Yritys',
  setup_vehicle: 'Ajoneuvot',
  'setup_vehicle-type': 'Ajoneuvotyypit',
  'setup_data-retentions': 'Tietojen säilytys',
  'add-data-retentions': 'Lisää tietojen säilytys',
  'data-retentions': 'Tietojen säilytys',
  setup_carriers: 'Kuljetusliikkeet',
  'add-carriers': 'Lisää kuljetusliike',
  carriers: 'Kuljetusliikkeet',
  'setup_concrete-classes': 'Materiaalin vaatimustenmukaisuus',
  'add-concrete-classes': 'Lisää materiaalin vaatimustenmukaisuus',
  'concrete-classes': 'Materiaalin vaatimustenmukaisuus',
  'setup_forms-and-waivers': 'Lomakkeet & Luopumiset',
  'add-forms-and-waivers': 'Lisää lomakkeet & luopumiset',
  'forms-and-waivers': 'Lomakkeet & Luopumiset',
  companyFleet: 'Yrityksen kalusto',
  category: 'Kategoria',
  interval: 'Aikaväli',
  orders: 'Tilaukset ja liput',
  '30days': '30 päivää',
  '60days': '60 päivää',
  '90days': '90 päivää',
  '1year': '1 vuosi',
  '3years': '3 vuotta',
  waterMandatory: 'Vesi pakollinen',
  qrCodeTemplate: 'QR-koodin malli',
  waterConfig: 'Valinnaiset kentät',
  waterProduct: 'Vesi',
  waterProductType: 'Veden tuotetyyppi',
  defaultWaterProduct: 'Oletus veden tuote',
  invalidTemplate: 'Virheellinen malli',
  siteAddress: 'Sivuston osoite',
  siteContactName: 'Sivuston yhteyshenkilön nimi',
  siteContactPhoneNumber: 'Sivuston yhteyshenkilön puhelinnumero',
  'clear-signature-button': 'Tyhjennä allekirjoitus',
  customerCommentEnabled: 'Ota käyttöön asiakaskommentti',
  driverCommentEnabled: 'Ota käyttöön kuljettajan kommentti',
  driverCommentMaxCharacters: 'Maksimipituus',
  customerCommentMaxCharacters: 'Maksimipituus',
  timeZone: 'Aikavyöhyke',
  driverDidNotAdd: 'Kuljettaja ei lisännyt',
  noWaterAdded: 'Kuljettaja ei lisännyt',
  maxLineItems: 'Maksimimäärä rivit',
  oneLineItem: 'Vähintään 1 rivin on oltava',
  signatureSiteContact: 'Asiakkaan nimi',
  signatureSiteContactMandatory: 'Asiakkaan nimi *',
  ticketEvents: 'Lipputapahtumat',
  hideEvent: 'Piilota tapahtuma',
  editable: 'Muokattava',
  ticketDetail: `Lippu #{value}`,
  statusTimes: 'Tilat ajat',
  materialAndDeliveryInfo: 'Materiaalit ja toimitustiedot',
  customerRejection: 'Asiakkaan hylkäys',
  'submit-rejection-button': 'Lähetä hylkäys',
  accept: 'Hyväksy',
  reject: 'Hylkää kuorma',
  signature: 'Allekirjoitus',
  'no-signature': 'Ei allekirjoitusta',
  unFinalizePassword: 'Poista viimeistelysalasana',
  waterInWorkflow: 'Ota käyttöön veden vaihe työnkulussa',
  multicountry: 'Monimaa',
  timestampAfterSequence: 'VAROITUS: Aika ei saa olla ennen edellistä aikaleimaa',
  timestampBeforeSequence: 'VAROITUS: Aika ei saa olla seuraavan aikaleiman jälkeen',
  noRestQuantity: 'Ei palautettua materiaalia',
  returnedMaterialMandatory: 'On pakko vuorovaikuttaa palautetun materiaalin vaiheen kanssa',
  driverCommentMaxChars: 'Pituus ei saa ylittää maksimiarvoa {maxLength} merkkiä.',
  QrCodeEnabled: 'Ota käyttöön QR-koodi',
  QrMethod_linkBased: 'Linkkipohjainen',
  QrMethod_contentBased:
    'Sisältöpohjainen, HUOM: Sisältöpohjaisilla QR-koodilla on merkkirajoituksia, jotka voivat aiheuttaa ongelmia yli 1024 merkkiä.',
  QrMethod_contentBasedWarning:
    'HUOM: Tässä QR-koodissa on {amount} merkkiä, jotka eivät ehkä ole luettavissa joillakin puhelimilla.',
  returnedMaterialInWorkflow: 'Ota käyttöön palautetun materiaalin vaihe työnkulussa',
  materialServiceInWorkflow: 'Ota käyttöön materiaali/palvelu vaihe työnkulussa',
  totalPumpedQuantity: 'Yhteensä pumpattu määrä',
  concrete: 'Betoni',
  materialComplianceEnabled: 'Ota käyttöön materiaalin vaatimustenmukaisuus',
  pumpStatusTimes: 'Pumppauksen tilat ajat',
  pollingInterval: 'Kyselyväli (sekuntia)',
  tenSecs: 'Välin on oltava vähintään 10 sekuntia',
  materialCompliance: 'Materiaalin vaatimustenmukaisuus',
  materialCompliance_notFound: 'Materiaalin vaatimustenmukaisuutta ei löytynyt',
  materialCompliance_outOfRange_warning: 'Syötetty arvo on betoniluokan toleranssialueen ulkopuolella.',
  consistenceValue: 'Konsistenssi - Löysäys',
  consistenceIsCompliant: 'Konsistenssi täyttää BS8500-2',
  airContentValue: 'Ilma sisältö',
  airContentIsCompliant: 'Ilma sisältö täyttää BS8500-2',
  consistenceIsCompliantShort: 'Konsistenssi täyttää',
  airContentIsCompliantShort: 'Ilma sisältö täyttää',
  compliance: 'Materiaalin vaatimustenmukaisuus BS8500-2',
  termsAndConditionsEnabled: 'Ota käyttöön ehtojen ja olosuhteiden lomake',
  termsAndConditions: 'Ehdot ja olosuhteet',
  damageWaiverEnabled: 'Ota käyttöön vahinkovapautuslomake',
  damageWaiver: 'Vahinkovapautus',
  damageWaiverAcknowledged: 'Vahinkovapautus tunnustettu',
  dynamicWaiver: 'Dynaaminen luopuminen',
  dynamicWaiverEnabled: 'Ota käyttöön dynaaminen luopumislomake',
  ticketListEnabled: 'Ota käyttöön lippulista',
  clearTicketAfterSubmission: 'Tyhjennä lippu lähettämisen jälkeen',
  keepTicketOpenAfterSubmission: 'Pidä lippu auki lähettämisen jälkeen',
  displayTicketList: 'Näytä lippulista',
  supportedLanguages: 'Tuetut kielet',
  allow: 'Salli',
  default: 'Oletus',
  isCertificationLossTriggerForReason: 'Sertifikaatin menetyksen syyn huomautus',
  isCertificationLossTriggerForProduct: 'Sertifikaatin menetyksen huomautus tuote',
  translations: 'Käännökset',
  family_name: 'Sukunimi',
  given_name: 'Etunimi',
  email: 'Sähköposti',
  role: 'Rooli',
  inviteUser: 'Kutsu käyttäjä',
  carrier: 'Kuljetusliike',
  emailOrPhoneNumber: 'Sähköposti',
  usersEditor: 'Käyttäjäeditori',
  verifyPassword: 'Vahvista salasana',
  verificationCode: 'Vahvistuskoodi',
  register: 'Rekisteröidy',
  registerInstructions: 'Täytä tämä lomake viimeistelläksesi rekisteröitymisesi.',
  'password-requirements':
    'Salasanasi on oltava vähintään 8 merkkiä pitkä, sisältää vähintään 1 iso kirjain, 1 pieni kirjain, 1 numero ja 1 erikoismerkki.',
  passwordMinCharacters: 'Salasanan on oltava vähintään 8 merkkiä pitkä.',
  passwordMaxCharacters: 'Salasana ei voi sisältää yli 99 merkkiä.',
  passwordLowerCase: 'Salasanan on sisällettävä 1 tai useampi pieni kirjain.',
  passwordUpperCase: 'Salasanan on sisällettävä 1 tai useampi iso kirjain.',
  passwordNumber: 'Salasanan on sisällettävä 1 tai useampi numeerinen merkki.',
  passwordSpecialCharacter: 'Salasanan on sisällettävä 1 tai useampi erikoismerkki.',
  passwordsDontMatch: 'Salasanat eivät täsmää!',
  success: 'Onnistui!',
  'registration-success': 'Rekisteröityminen onnistui.',
  'post-registration-instructions': 'Olet suorittanut rekisteröintiprosessin. Voit nyt kirjautua sisään.',
  createDate: 'Luontipäivämäärä',
  customerPo: 'Asiakkaan PO-numero',
  specification: 'Erityisvaatimukset',
  description: 'Kuvaus',
  classType: 'Luokkatyypit',
  minimumValue: 'Minimiarvo',
  maximumValue: 'Maksimiarvo',
  TrackIt: 'TrackIt',
  trackIt3PContext: 'TrackIt 3P konteksti',
  inviteLanguage: 'Kutsukieli',
  truckNumber: 'Kuorma-auton numero',
  adverseTemperature:
    'Ympäristön lämpötila sekoituksen aikana oli sellainen, että emme voi taata, että betoni on lämpötila-alueilla 5-35 °C kuten EN 206:ssa on määritelty.',
  environmentalNote:
    'Tämä kuorma sisältää ympäristöaineen, joka ei ylitä 0,03 % painosta betonista. Tällä materiaalilla valmistettu vesi betonin valmistukseen täyttää BS EN 1008:n vaatimukset.',
  unloadingMethodEnabled: 'Ota käyttöön purku menetelmä',
  warrantyVoided: 'Materiaalin takuu mitätöity',
  materialWarrantyVoidedEnabled:
    'Kun sertifikaatin menetyksen huomautus tuotetta tai tuotetta & syykoodia käytetään, näytä sertifikaatin menetyksen huomautus allekirjoitushetkellä.',
  'setup_templates-mt': 'Mallit',
  copyFrom: 'Kopioi...',
  copy: 'kopio',
  users: 'Käyttäjät',
  setup: 'Asetukset',
  driverExperience: 'Kuljettajan kokemus',
  ticketList: 'Lippulista',
  content: 'Sisältö',
  WARNINGS: 'Varoitukset',
  TERMS: 'Ehdot',
  DAMAGE: 'Vahinko',
  ADDITIONALWAIVER: 'Lisäluopuminen',
  DYNAMICWAIVER: 'Dynaaminen luopuminen',
  source: 'Lähde',
  sensorUnable: 'Anturi ei pysty määrittämään ylijäämämäärää.',
  PROBE: 'Anturi',
  DRIVER: 'Kuljettaja',
  DRS: 'DRS',
  waterReleaseFormEnabled: 'Ota käyttöön veden vapautuslomake',
  waterReleaseMandatory: 'Veden vapautus *',
  waterRelease: 'Veden vapautus',
  waterReleaseAcknowledged: 'Veden vapautus tunnustettu',
  'assessment-risk': 'Riskinarviointi',
  'setup_assessment-risk': 'Riskinarviointi',
  'add-assessment-risk': 'Lisää riskinarviointi',
  enterRecipientsButton: 'Syötä vastaanottaja(t)',
  recipientsInstructions: 'Syötä sähköposti, erotettuna pilkulla',
  enter: 'Syötä',
  invalidEmailAddress: 'Virheellinen sähköpostiosoite',
  personalDataPolicy:
    'Syöttämällä henkilökohtaisia tietoja tähän lomakkeeseen vahvistat, että sinulla on tarvittavat luvat jakaa nämä henkilökohtaiset tiedot',
  subcategory: 'Alakategoria',
  isRequired: 'Onko pakollinen',
  riskAssessmentEnabled: 'Ota käyttöön riskinarviointi',
  riskAssessment: 'Riskinarviointi',
  yes: 'Kyllä',
  no: 'Ei',
  sourceOptionsSensors: 'Lähteen vaihtoehdot (anturi)',
  sourceDcm: 'DCM',
  sourceProbe: 'Anturi',
  availableCustomValues: 'Saatavilla olevat mukautetut arvot',
  ERR_CODE__DUPLICATE: 'Kaksinkertainen',
  ERR_CODE__DEFAULT_VALUE: 'Oletusarvo on jo olemassa',
  ERR_CODE__EXISTING_FORM: 'Tälle ajoneuvolle ja tyypille on jo aktiivinen lomake',
  availableValues: 'Saatavilla olevat arvot',
  pump: 'Pumppu',
  DanskName: 'Tanskalainen nimi',
  GermanName: 'Saksalainen nimi',
  EnglishName: 'Englanninkielinen nimi',
  BritainName: 'Britannian nimi',
  SpanishName: 'Espanjalainen nimi',
  FrenchName: 'Ranskalainen nimi',
  NederlandsName: 'Hollantilainen nimi',
  NorskName: 'Norjalainen nimi',
  SvenskaName: 'Ruotsalainen nimi',
  ItalianName: 'Italian nimi',
  PolishName: 'Puolan nimi',
  DanskNameDefault: 'Tanskalainen nimi (Oletus)',
  GermanNameDefault: 'Saksalainen nimi (Oletus)',
  EnglishNameDefault: 'Englanninkielinen nimi (Oletus)',
  BritainNameDefault: 'Britannian nimi (Oletus)',
  SpanishNameDefault: 'Espanjalainen nimi (Oletus)',
  FrenchNameDefault: 'Ranskalainen nimi (Oletus)',
  NederlandsNameDefault: 'Hollantilainen nimi (Oletus)',
  NorskNameDefault: 'Norjalainen nimi (Oletus)',
  SvenskaNameDefault: 'Ruotsalainen nimi (Oletus)',
  ItalianNameDefault: 'Italian nimi (Oletus)',
  PolishNameDefault: 'Puolan nimi (Oletus)',
  DanskDescription: 'Tanskalainen kuvaus',
  GermanDescription: 'Saksalainen kuvaus',
  EnglishDescription: 'Englanninkielinen kuvaus',
  BritainDescription: 'Britannian kuvaus',
  SpanishDescription: 'Espanjalainen kuvaus',
  FrenchDescription: 'Ranskalainen kuvaus',
  NederlandsDescription: 'Hollantilainen kuvaus',
  NorskDescription: 'Norjalainen kuvaus',
  SvenskaDescription: 'Ruotsalainen kuvaus',
  ItalianDescription: 'Italian kuvaus',
  PolishDescription: 'Puolan kuvaus',
  DanskDescriptionDefault: 'Tanskalainen kuvaus (Oletus)',
  GermanDescriptionDefault: 'Saksalainen kuvaus (Oletus)',
  EnglishDescriptionDefault: 'Englanninkielinen kuvaus (Oletus)',
  BritainDescriptionDefault: 'Britannian kuvaus (Oletus)',
  SpanishDescriptionDefault: 'Espanjalainen kuvaus (Oletus)',
  FrenchDescriptionDefault: 'Ranskalainen kuvaus (Oletus)',
  NederlandsDescriptionDefault: 'Hollantilainen kuvaus (Oletus)',
  NorskDescriptionDefault: 'Norjalainen kuvaus (Oletus)',
  SvenskaDescriptionDefault: 'Ruotsalainen kuvaus (Oletus)',
  ItalianDescriptionDefault: 'Italian kuvaus (Oletus)',
  PolishDescriptionDefault: 'Puolan kuvaus (Oletus)',
  DanskContent: 'Tanskalainen sisältö',
  GermanContent: 'Saksalainen sisältö',
  EnglishContent: 'Englanninkielinen sisältö',
  BritainContent: 'Britannian sisältö',
  SpanishContent: 'Espanjalainen sisältö',
  FrenchContent: 'Ranskalainen sisältö',
  NederlandsContent: 'Hollantilainen sisältö',
  NorskContent: 'Norjalainen sisältö',
  SvenskaContent: 'Ruotsalainen sisältö',
  ItalianContent: 'Italian sisältö',
  PolishContent: 'Puolan sisältö',
  DanskContentDefault: 'Tanskalainen sisältö (Oletus)',
  GermanContentDefault: 'Saksalainen sisältö (Oletus)',
  EnglishContentDefault: 'Englanninkielinen sisältö (Oletus)',
  BritainContentDefault: 'Britannian sisältö (Oletus)',
  SpanishContentDefault: 'Espanjalainen sisältö (Oletus)',
  FrenchContentDefault: 'Ranskalainen sisältö (Oletus)',
  NederlandsContentDefault: 'Hollantilainen sisältö (Oletus)',
  NorskContentDefault: 'Norjalainen sisältö (Oletus)',
  SvenskaContentDefault: 'Ruotsalainen sisältö (Oletus)',
  ItalianContentDefault: 'Italian sisältö (Oletus)',
  PolishContentDefault: 'Puolan sisältö (Oletus)',
  DanskCategory: 'Tanskalainen kategoria',
  GermanCategory: 'Saksalainen kategoria',
  EnglishCategory: 'Englanninkielinen kategoria',
  BritainCategory: 'Britannian kategoria',
  SpanishCategory: 'Espanjalainen kategoria',
  FrenchCategory: 'Ranskalainen kategoria',
  NederlandsCategory: 'Hollantilainen kategoria',
  NorskCategory: 'Norjalainen kategoria',
  SvenskaCategory: 'Ruotsalainen kategoria',
  ItalianCategory: 'Italian kategoria',
  PolishCategory: 'Puolan kategoria',
  DanskCategoryDefault: 'Tanskalainen kategoria (Oletus)',
  GermanCategoryDefault: 'Saksalainen kategoria (Oletus)',
  EnglishCategoryDefault: 'Englanninkielinen kategoria (Oletus)',
  BritainCategoryDefault: 'Britannian kategoria (Oletus)',
  SpanishCategoryDefault: 'Espanjalainen kategoria (Oletus)',
  FrenchCategoryDefault: 'Ranskalainen kategoria (Oletus)',
  NederlandsCategoryDefault: 'Hollantilainen kategoria (Oletus)',
  NorskCategoryDefault: 'Norjalainen kategoria (Oletus)',
  SvenskaCategoryDefault: 'Ruotsalainen kategoria (Oletus)',
  ItalianCategoryDefault: 'Italian kategoria (Oletus)',
  PolishCategoryDefault: 'Puolan kategoria (Oletus)',
  DanskSubcategory: 'Tanskalainen alakategoria',
  GermanSubcategory: 'Saksalainen alakategoria',
  EnglishSubcategory: 'Englanninkielinen alakategoria',
  BritainSubcategory: 'Britannian alakategoria',
  SpanishSubcategory: 'Espanjalainen alakategoria',
  FrenchSubcategory: 'Ranskalainen alakategoria',
  NederlandsSubcategory: 'Hollantilainen alakategoria',
  NorskSubcategory: 'Norjalainen alakategoria',
  SvenskaSubcategory: 'Ruotsalainen alakategoria',
  ItalianSubcategory: 'Italian alakategoria',
  PolishSubcategory: 'Puolan alakategoria',
  DanskSubcategoryDefault: 'Tanskalainen alakategoria (Oletus)',
  GermanSubcategoryDefault: 'Saksalainen alakategoria (Oletus)',
  EnglishSubcategoryDefault: 'Englanninkielinen alakategoria (Oletus)',
  BritainSubcategoryDefault: 'Britannian alakategoria (Oletus)',
  SpanishSubcategoryDefault: 'Espanjalainen alakategoria (Oletus)',
  FrenchSubcategoryDefault: 'Ranskalainen alakategoria (Oletus)',
  NederlandsSubcategoryDefault: 'Hollantilainen alakategoria (Oletus)',
  NorskSubcategoryDefault: 'Norjalainen alakategoria (Oletus)',
  SvenskaSubcategoryDefault: 'Ruotsalainen alakategoria (Oletus)',
  ItalianSubcategoryDefault: 'Italian alakategoria (Oletus)',
  PolishSubcategoryDefault: 'Puolan alakategoria (Oletus)',
  priorSignatures: 'Aikaisemmat allekirjoitukset',
  damageWaiverSignature: 'Vahinkovapautuksen allekirjoitus',
  waterReleaseSignature: 'Veden vapautuksen allekirjoitus',
  errors,
  themes,
  isPDFRecipientListEnable: 'Ota käyttöön PDF-vastaanottajalista asiakassivulla',
  isRejectLoadsEnable: 'Ota käyttöön kuormien hylkääminen saapumisen jälkeen',
  rejectLoad_returnedMaterial: 'Palautetun materiaalin työnkulku painike',
  rejectLoad_returnedAndFinalize: 'Palautetun materiaalin ja viimeistelyn työnkulku painikkeet',
  driverRejection: 'Hylkää kuorma',
  submitRejection: 'Lähetä hylkäys',

  costAndPaymentsSummary: 'Kustannus- ja maksuyhteenveto',
  groupCostPriorTotal: 'Tilaus Toimituskulut Ennen Yhteensä',
  subtotal: 'Väli summa',
  tax: 'Verot',
  remainingBalance: 'Jäljellä oleva saldo',
  paymentAmount: 'Maksusumma',
  total: 'Yhteensä',
  paymentMethod: 'Maksutapa',
  paymentProducts: 'Tuotteet',
  unitPrice: 'Yksikköhinta',
  amount: 'Määrä',
  otherPaymentMethod: 'Muu maksutapa',
  method: 'Menetelmä',
  paymentOptions: 'Maksuvaihtoehdot',
  typeAdditionalInfo: 'Kirjoita lisätietoja tähän',
  COD: 'Käteismaksu',
  AMEX: 'American Express',
  CASH: 'Käteinen',
  CHECK: 'Tarkistus',
  'CREDIT CARD': 'Luottokortti',
  ACCOUNT: 'Avoin tili',
  UNKNOWN: 'Tuntematon',
  remainingMaterial: 'Jäljellä oleva materiaali',
  splitLoad: 'Jaettu kuorma - Useita',
  isEnablePaymentAndCostWorkflows: 'Ota käyttöön maksujen ja kustannusten työnkulut',

  // DOT Workflow
  dotWorkflow: 'Erä tiedot',
  inspectorSignature: 'Tarkastajan allekirjoitus',
  producerSignature: 'Tuottajan allekirjoitus',
  addedItems: 'Lisätyt kohteet',
  producerSignatureContact: 'Tuottajan nimi',
  inspectorSignatureContact: 'Tarkastajan nimi',

  //
  airTempValue: 'Ilman lämpötila',
  concreteTempValue: 'Betonin lämpötila',
  cylinderNumber: 'Sylinterin numero',
  materialOnTruck: 'Materiaali kuorma-autossa',
  waterLocation: 'Veden sijainti',
  waterAtPlant: 'Vesi tehtaalla (gl)',
  waterAtJobsite: 'Vesi työmaalla (gl)',
  totalActualWater: 'Yhteensä todellinen vesi',
  timeDischarged: 'Purkuaika',
  // news
  ingredient: 'Ainesosa',
  mcFac: 'MCFac',
  absFac: 'ABSFAC',
  od: 'OD',
  abs: 'ABS',
  ssd: 'SSD',
  freeMst: 'Vapaa Mst',
  cydsTarg: 'CYDS TARG',
  target: 'Tavoite',
  actual: 'Todellinen',
  freWat: 'Vapaa vesi',
  trim: 'Trim',
  batchInformation: 'Erätiedot',
  numberOfBatches: 'Erien määrä',
  totalWater: 'Yhteensä vettä',
  designWater: 'Suunnitteluvesi',
  toAdd: 'Lisättävä',
  designWC: 'Suunnittelu W/C',
  waterCement: 'Vesi / Sementti',
  waterInTruck: 'Vesi kuorma-autossa',
  adjustWater: 'Säädä vettä',
  trimWater: 'Trimmaa vettä',
  plantWeather: 'Tehtaan sää',
  rh: 'RH',
  observationTime: 'Havainnointiaika',
  address: 'Osoite',
  plant: 'Tehdas',
  sp: 'S.P. #',
  beginTime: 'Aloita aika',
  mixDesc: 'Sekoita kuvaus',
  qtyOder: 'Määrä tilaus',
  poTag: 'PO #',
  bridge: 'Silta #',
  volume: 'Tilavuus',
  truckTag: 'Kuorma-auto #',
  qtyDelivered: 'Määrä toimitettu',
  qtyOrder: 'Määrä tilaus',
  job: 'Työ #',
  batchRecord: 'Erärekisteri',
  mixID: 'Sekoita ID',
  loads: 'Kuormat',
  isDot: 'On DOT',
  onlyPrimaryLineItem: 'Vain ensisijainen rivikohta',
  tolStatus: 'TOL Tila',
  lastUpdate: 'Viimeisin päivitys',
  driverClickedFinalize: 'Kuljettaja napsautti viimeistelyä',
  autoSubmit: 'Automaattinen lähetys',
  noTaxInformationIsAvailable: 'Verotietoja ei ole saatavilla',
  retryPullTaxInformation: 'Päivitä verotiedot',
  var: '% Var',
  designQTY: 'Suunnittelu määrä',
  batched: 'Erätty',
  moisture: 'Kosteus',
  actualWater: 'Todellinen vesi',
  moisturePercent: '% Kosteus',
  freeWater: 'Vapaa vesi',
  reset: 'Nollaa',
  'at-plant': 'Tehtaalla',
  'at-job': 'Työmaalla',
  viewTickets: 'Näytä liput',
  viewSchedule: 'Näytä aikataulu',
  viewActiveTicket: 'Näytä aktiivinen lippu',
  dateSelector_last_week: 'Viime viikko',
  dateSelector_yesterday: 'Eilen',
  dateSelector_tomorrow: 'Huomenna',
  dateSelector_last_week: 'Viimeiset 7 päivää',
  dateSelector_today: 'Tänään',
  gridHeader_created: 'Luotu',
  gridHeader_customerStatus: 'Asiakkaan tila',
  gridHeader_ticketId: 'Lippu',
  gridHeader_customerStatus: 'Asiakkaan tila',
  gridHeader_vehicle: 'Ajoneuvo',
  gridFooter_retrieved: 'Haettu',
  gridFooter_loading: 'Ladataan...',
  general: {
    ...CAI_MATERIAL.i18n['en-US'].general,
  },
  component: {
    ...CAI_MATERIAL.i18n['en-US'].component,
  },
  attachments: 'Liitteet',
  priorOrderCostTotal: 'Aiempi kokonaissumma',
  priorOrderPaymentTotal: 'Aiemmat maksut',
  orderShippedCostTotal: 'Tilauksen kokonaissumma',
  orderShippedBalance: 'Tilauksen saldo',
  ticketSubtotal: 'Lipukkeen välisumma',
  ticketTax: 'Lipukkeen vero',
  ticketTotal: 'Lipukkeen kokonaissumma',
  driverId: 'Kuljettajan tunnus',
  ticketStatus: 'Lipukkeen tila',
  voided: 'Mitätöity',
  ticketVoidedNotification: 'Tämä lipuke on mitätöity.',
  ticketed: 'Myönnetty',
};
